<template>
  <div>
    <div class="document-wrapper">
      <div class="document" >


        <template v-if="isImage()">
          <el-image
              @click.stop="openFile()"
              class="images-content"
              fit="cover"
              :src="getUrlPhoto()"
          >
            <div slot="error" class="images-content_error">
              <i class="el-icon-picture-outline"></i> Ошибка загрузки
            </div>
            <div slot="placeholder" class="images-content_loading">
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
        </template>
        <template v-else>
          <div @click.stop="openFile" class="document__icon">
            <file-icon></file-icon>
          </div>
        </template>

        <div class="document__date text-block">
          <div class="text-block__title">{{ fileName }}</div>
          <div class="text-block__subtitle"> {{ file.ext }}</div>
        </div>

        <div style="flex: 1"></div>

        <div class="document__buttons">

          <el-button type="text" size="mini" @click="deleteFile" :loading="loading" icon="el-icon-close"></el-button>


        </div>
      </div>




    </div>

  </div>
</template>

<script>
import FileIcon from "@/components/icons/File"

export default {
  name: "UploadFile",
  data() {
    return {
      fileName: this.file.full_title,
      loading: false,
      editable: false,
      downloadLoading: false,
      isVisibleFileViewer: false,
    }
  },
  components: {

    FileIcon
  },
  props: {
    file: {},
    user: {}
  },
  watch: {},
  computed: {},
  methods: {
    isImage() {
      let type = this.file.ext
      return type === "jpeg" || type === "jpg" || type === "png"
    },
    getUrlPhoto() {
      return this.$root.getUrlPhoto(this.file.link.get)
    },
    openFile() {
      this.$emit('openPhoto', this.file)

      // this.isVisibleFileViewer = true
    },
    deleteFile() {
      this.$emit('delete', this.file)

    }
  }
}
</script>

<style scoped lang="scss">
.document-wrapper {

  border-radius: 6px;
  margin: 12px 0;


}

.document {

  height: 60px;


  display: flex;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid #EAEAEA;


  &__icon {
    width: 26px;
    font-size: 26px;
  }

  &__title {
    margin-left: 23px;
    flex: 1;

    font-size: 13px;
    line-height: 16px;


    color: #111;

  }

  &__type {
    min-width: 150px;
    margin-left: 30px;
  }

  &__date {
    margin-left: 20px;
  }

  &__buttons {
    margin-left: 30px;

    i {
      margin-left: 10px;
      transition: all .3s ease;
      color: #000000;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: #32E6BE;
      }

    }
  }

}


.text-block {
  font-size: 13px;
  line-height: 16px;

  &__title {
    font-size: 14px;
    line-height: 22px;
    color: #111;
  }

  &__subtitle {

    padding: 2px 0;
    font-size: 14px;
    line-height: 22px;

    display: flex;
    align-items: center;
    letter-spacing: -0.2px;

    color: #8E8E93;

  }
}


.images-content {
  width: 40px;
  height: 40px;

  cursor: pointer;
  border-radius: 4px;

  transition: all .2s ease;

  &:hover {
    opacity: .8;
  }

  &_name {

  }

  &_loading {
    width: 40px;
    height: 40px;

    text-align: center;
    background: #e3e3e3;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.comment {
  padding: 16px;
  border-top: 1px solid #E4E7ED;

}

.btns {
  margin-top: 12px;
  text-align: right;
}

</style>
